// extracted by mini-css-extract-plugin
export default {"content":"_2TmG8","offerInAccount":"_1xrcj","title2":"Qawny","cguApple":"lBYr7","restoreButtonContainer":"_2yJt6","restoreButton":"e-ERh"};